import { tr } from '@/lib/i18n-core';
import { Badge, StatusBadge } from '@/components/ui/primitives';
import { orderSummaryRows, type OrderSummaryEncounter } from './summary';
import type { OrderKind } from './types';

export function OrderSummaryList({ encounter, kind }: { encounter: OrderSummaryEncounter; kind: OrderKind }) {
  const rows = orderSummaryRows(encounter, kind);
  return (
    <ul className="space-y-1.5">
      {rows.map((row) => (
        <li key={row.key} className="flex items-center justify-between gap-2">
          <span className="min-w-0 truncate">
            {row.label}
            {row.quantity > 1 && <span className="ms-1 text-xs text-muted-foreground tabular">×{row.quantity}</span>}
          </span>
          {row.outside ? <Badge variant="muted">{tr('opd', 'order_outside')}</Badge> : <StatusBadge status={row.status} />}
        </li>
      ))}
    </ul>
  );
}
